import styled from 'styled-components'

export const ResourceCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 0 16px 0;
    gap: 12px;

    &:not(:last-child) {
        border-bottom: 1px solid ${({ theme }) => theme['gray-300']};

        > .operation-list {
            > div:last-child {
                > .bowtie-list {
                    > .bowtie-name {
                        &:last-child {
                            margin-bottom: 12px;
                        }
                    }
                }
            }
        }
    }

    .fa-caret-down,
    .fa-caret-up {
        color: ${({ theme }) => theme['blue-700']};
    }

    input[type='checkbox'] {
        accent-color: ${({ theme }) => theme['blue-700']};
        margin-left: auto;
    }

    .resource-name {
        font-family: var(--font-semibold);
        display: flex;
        font-size: 13px;
        align-items: center;
        gap: 6px;
    }

    .operation-list {
        display: flex;
        gap: 12px;
        flex-direction: column;
    }
`
